/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Stcoldate2Inputs */

const zh_landing_admin_stcoldate2 = /** @type {(inputs: Landing_Admin_Stcoldate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成日期`)
};

const en_landing_admin_stcoldate2 = /** @type {(inputs: Landing_Admin_Stcoldate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish date`)
};

const es_landing_admin_stcoldate2 = /** @type {(inputs: Landing_Admin_Stcoldate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de finalización`)
};

/**
* | output |
* | --- |
* | "Finish date" |
*
* @param {Landing_Admin_Stcoldate2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_stcoldate2 = /** @type {((inputs?: Landing_Admin_Stcoldate2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Stcoldate2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_stcoldate2(inputs)
	if (locale === "en") return en_landing_admin_stcoldate2(inputs)
	return es_landing_admin_stcoldate2(inputs)
});
export { landing_admin_stcoldate2 as "landing_admin_stColDate" }